import Enumerator from './Enumerator';

export const levelOptions = ['none', 'low', 'medium', 'high'];

export class LevelOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'low';
        break;
      case '2':
        correctOption = 'medium';
        break;
      case '3':
        correctOption = 'high';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

LevelOption.initEnum(levelOptions);

export default {
  levelOptions,
  LevelOption
};
